import { Box, Grid } from "@mui/material";
import Libelle from "../../../_i18n/fr.json";
import Bouton from "../../../components/Button/Bouton";
import LoadingBoundary from "../../../components/LoadingBoundary";
import MessageInfo from "../../../components/MessageInfo";
import Snack from "../../../components/Snack";
import styles from "../styles";
import CriteresRecherche from "./CriteresRecherche";
import ResultatsRecherche from "./ResultatsRecherche";
import { useRechercheUtilisateur } from "./selectors";

function RechercherUtilisateur() {
  const {
    handleClick,
    handleClickBesse,
    handleChangeCritere,
    handleRechercher,
    lancerRecherche,
    handleReessayer,
    handleChangeTri,
    handleChangePage,
    handleChangeNbrElementParPage,
    handleChangeStatut,
    handleConsulter,
    fonctionsPostes,
    confirmationActivationUtilisateur,
    confirmationDesactivationUtilisateur,
    desactiverFetching,
    desactiverError,
    searchResults,
    searchCount,
    searching,
    searchError,
    isChargeClienteleBesse,
    utilisateurConnecte,
    idAdb,
    criteres,
    handleClose,
    pagination,
    showConfirmationCreation,
    searchParams,
    errorGetUtilisateur,
    resetGetUtilisateur,
  } = useRechercheUtilisateur();

  const onlyBesse =
    utilisateurConnecte && utilisateurConnecte.role === "BESSE" && !idAdb;

  const initialValues = {
    nom: criteres.nom,
    prenom: criteres.prenom,
    fonction: criteres.fonction,
    statut: criteres.statut,
    profilBesse: criteres.profilBesse,
  };

  const infoAdbUtilisateurs = onlyBesse ? (
    <MessageInfo
      messageUrl="sélectionner un administrateur de bien"
      url="/mes-administrateurs-de-biens"
    >
      Pour visualiser les utilisateurs d'un administrateur de bien, veuillez en
      sélectionner un :
    </MessageInfo>
  ) : (
    ""
  );
  return (
    <Box className={"container"} sx={styles}>
      {showConfirmationCreation && (
        <Snack
          onClose={handleClose}
          open={showConfirmationCreation}
          variant="success"
          message="Félicitations l'utilisateur a bien été sauvegardé"
        />
      )}

      {confirmationDesactivationUtilisateur && (
        <Snack
          onClose={handleClose}
          open={confirmationDesactivationUtilisateur}
          variant="success"
          message="Sauvegarde réussie. L'utilisateur est bien désactivé."
        />
      )}

      {confirmationActivationUtilisateur && (
        <Snack
          onClose={handleClose}
          open={confirmationActivationUtilisateur}
          variant="success"
          message="Sauvegarde réussie. L'utilisateur est bien activé."
        />
      )}
      {errorGetUtilisateur && (
        <Snack
          onClose={resetGetUtilisateur}
          open={errorGetUtilisateur}
          variant="error"
          message={errorGetUtilisateur.message}
        />
      )}

      <h2>{Libelle.pageUtilisateurs.titre}</h2>
      {infoAdbUtilisateurs}

      {((onlyBesse && !isChargeClienteleBesse) ||
        idAdb ||
        (utilisateurConnecte && utilisateurConnecte.role === "ADB")) && (
        <>
          <CriteresRecherche
            initialValues={initialValues}
            onChangeCritere={handleChangeCritere}
            onRechercher={handleRechercher}
            idAdb={idAdb}
            utilisateurBesse={
              utilisateurConnecte && utilisateurConnecte.role === "BESSE"
            }
            isChargeClienteleBesse={isChargeClienteleBesse}
          />
          <LoadingBoundary
            error={searchError}
            loading={searching}
            onRetry={handleReessayer}
          >
            {searchResults && (
              <ResultatsRecherche
                onChangeNbrElementParPage={handleChangeNbrElementParPage}
                onChangePage={handleChangePage}
                onChangeTri={handleChangeTri}
                searchResults={searchResults}
                searchCount={searchCount}
                nbrElementParPage={pagination.nbrElementParPage}
                sortColumn={pagination.sortColumn}
                sortOrder={pagination.sortOrder}
                page={pagination.page}
                onlyBesse={onlyBesse}
                searchParams={searchParams}
                fonctionsPostes={fonctionsPostes}
                onChangeStatut={handleChangeStatut}
                handleConsulter={handleConsulter}
                isChargeClienteleBesse={isChargeClienteleBesse}
              />
            )}
          </LoadingBoundary>
        </>
      )}
      <Grid container className={"containerButton"} justifyContent="flex-end">
        {utilisateurConnecte &&
          utilisateurConnecte.role === "BESSE" &&
          !isChargeClienteleBesse && (
            <Bouton
              label="Ajouter un utilisateur BESSE"
              variant="contained"
              color="primary"
              style={{ marginRight: 24 }}
              size="medium"
              onClick={handleClickBesse}
            />
          )}
        {((idAdb && !isChargeClienteleBesse) ||
          (utilisateurConnecte && utilisateurConnecte.role === "ADB")) && (
          <Bouton
            label="Ajouter un utilisateur"
            variant="contained"
            color="primary"
            size="medium"
            onClick={handleClick}
          />
        )}
      </Grid>
    </Box>
  );
}

export default RechercherUtilisateur;
